import React from "react";
import Character from "./Character";
import Background from "./Background";

function Scene({ background, character }) {
  return (
    <div className="vn-scene">
      <Background type={background} />
      <div className="vn-scene-overlay" />
      <Character character={character} />
    </div>
  );
}

export default Scene;
